import React, { useState, useEffect, useCallback } from "react";
import * as XLSX from "xlsx"; // For Excel export

import { useLocation, useNavigate } from "react-router-dom";
import { makeAuthenticatedRequest } from "../../utils/apiRequest";
import { useAuth } from "../../contexts/authContext";
import EntranceFeePopup from "./EntranceFeePopup";
import OtherExpensesPopup from "./OtherExpensesPopup";
import MiscellaneousExpensesPopup from "./MiscellaneousExpensesPopup";
import GuideAccommodationPopup from "./GuideAccommodationPopup";
import AccommodationPopup from "./AccommodationPopup";
import TransportPopup from "./TransportPopup";

const Costing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { itineraryId } = location.state || {};
  const { token } = useAuth();

  // State to hold the Excel download link from API
  const [excelLink, setExcelLink] = useState("");
  const [excelError, setExcelError] = useState("");
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itinerary, setItinerary] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const [days, setDays] = useState([]);
  const [isEntranceFeePopupOpen, setIsEntranceFeePopupOpen] = useState(false);
  const [isOtherExpensesPopupOpen, setIsOtherExpensesPopupOpen] = useState(false);
  const [isMiscellaneousExpensesPopupOpen, setIsMiscellaneousExpensesPopupOpen] = useState(false);
  const [isGuideAccommodationPopupOpen, setIsGuideAccommodationPopupOpen] = useState(false);
  const [isAccommodationPopupOpen, setIsAccommodationPopupOpen] = useState(false);
  const [isTransportPopupOpen, setIsTransportPopupOpen] = useState(false);
  const [costBreakdown, setCostBreakdown] = useState({
    transport: { withVAT: 0, withoutVAT: 0 },
    accommodation: { withVAT: 0, withoutVAT: 0 },
    entranceFees: { withVAT: 0, withoutVAT: 0 },
    miscellaneousExpenses: { withVAT: 0, withoutVAT: 0 },
    otherExpenses: { withVAT: 0, withoutVAT: 0 },
    guideAccommodation: { withVAT: 0, withoutVAT: 0 },
    markupFixedRate: { withVAT: 0, withoutVAT: 0 }, // For future use
    vat: { withVAT: 0, withoutVAT: 0 }, // For future use
    sellingRate: { withVAT: 0, withoutVAT: 0 } // For future use
  });
  const [accommodationByRoom, setAccommodationByRoom] = useState([]); // NEW STATE
 const [summary, setSummary] = useState({
  totalMileage: 0,
  workingDays: 0,
  selectedVehicle: '',
  customerName: '',
  customerId: '',
  numAdults: 0,
  numChildren: 0
});

const [showExcelLink, setShowExcelLink] = useState(false);
  // Helper: true if any popup is open
  const isAnyPopupOpen =
    isEntranceFeePopupOpen ||
    isOtherExpensesPopupOpen ||
    isMiscellaneousExpensesPopupOpen ||
    isGuideAccommodationPopupOpen ||
    isAccommodationPopupOpen ||
    isTransportPopupOpen;

    const [packagePrices, setPackagePrices] = useState({
  dbl_packedge_price: 0,
  sgl_packedge_price: 0,
  tpl_packedge_price: 0
});

// ADD THIS: New state for per person accommodation prices
const [perPersonAccommodationPrices, setPerPersonAccommodationPrices] = useState({
  dbl_accomodation_price_per_person: 0,
  sgl_accomodation_price_per_person: 0,
  tpl_accomodation_price_per_person: 0
});

const [showTaxes, setShowTaxes] = useState(false);
const [taxData, setTaxData] = useState([]);

const [excelLoading, setExcelLoading] = useState(false);

const [taxLoading, setTaxLoading] = useState(false);



  // Fetch all relevant cost data from the module totals endpoint
const fetchModuleTotalsData = useCallback(async () => {
  if (!token || !itineraryId) return {};
  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_module_totals_data",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ itinerary_id: itineraryId }),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error fetching module totals! status: ${response.status}`);
    }
    const data = await response.json();
    console.log('Module totals data:', data);
    
    // Convert array of {key: {with_VAT, without_vat}} to a flat object with both values
    const totals = {};
    let roomCategory = [];
    let packagePricesData = {
      dbl_packedge_price: 0,
      sgl_packedge_price: 0,
      tpl_packedge_price: 0
    };
    let adultsChildrenData = {
      numAdults: 0,
      numChildren: 0
    };
    let perPersonAccommodationPrices = {
      dbl_accomodation_price_per_person: 0,
      sgl_accomodation_price_per_person: 0,
      tpl_accomodation_price_per_person: 0
    };
    let taxesData = [];
    let taxStatus = false;
    // ADD THIS: New variable for profit margin data
    let profitMarginData = null;
    
    if (data && Array.isArray(data.data)) {
      data.data.forEach(item => {
        const key = Object.keys(item)[0];
        const entry = item[key] || {};
        if (key === "accomodation_by_room_category") {
          roomCategory = Array.isArray(entry) ? entry : [];
        } else if (key === "packedge_prices") {
          packagePricesData = {
            dbl_packedge_price: entry.dbl_packedge_price || 0,
            sgl_packedge_price: entry.sgl_packedge_price || 0,
            tpl_packedge_price: entry.tpl_packedge_price || 0
          };
        } else if (key === "head_count") {
          adultsChildrenData = {
            numAdults: entry.numAdults || 0,
            numChildren: entry.numChildren || 0
          };
        } else if (key === "per_person_accomodation_price") {
          perPersonAccommodationPrices = {
            dbl_accomodation_price_per_person: entry.dbl_accomodation_price_per_person || 0,
            sgl_accomodation_price_per_person: entry.sgl_accomodation_price_per_person || 0,
            tpl_accomodation_price_per_person: entry.tpl_accomodation_price_per_person || 0
          };
        } else if (key === "taxes") {
          taxesData = Array.isArray(entry) ? entry : [];
        } else if (key === "tax_for_without_tax_items_status") {
          taxStatus = entry === true;
        } 
        // ADD THIS: Extract profit margin data
        else if (key === "profit_margin") {
          profitMarginData = entry;
        } 
        else {
          totals[key] = {
            withVAT: entry.with_VAT?.value ?? 0,
            withoutVAT: entry.without_vat?.value ?? 0,
          };
        }
      });
    }
    return { 
      totals, 
      roomCategory, 
      packagePricesData, 
      adultsChildrenData, 
      perPersonAccommodationPrices, 
      taxesData, 
      taxStatus,
      profitMarginData  // ADD THIS
    };
  } catch (err) {
    console.error('Error fetching module totals data:', err);
    return {};
  }
}, [token, itineraryId]);

  // Calculate costs based on itinerary data
 const calculateCosts = useCallback(async (itineraryData) => {
  const { 
    totals, 
    roomCategory, 
    packagePricesData, 
    adultsChildrenData, 
    perPersonAccommodationPrices, 
    taxesData, 
    taxStatus,
    profitMarginData  // ADD THIS
  } = await fetchModuleTotalsData();
  
  // Get data from the itinerary response
  const days = itineraryData.no_of_days || 1;
  // Check if vehicle details are nested inside bookingDetails
  const vehicleDetails = itineraryData.bookingDetails?.vehicleDetails || {};
  console.log('Costing: Vehicle details from API:', vehicleDetails);
  
  // Set summary data using values from API response
  setSummary({
    totalMileage: itineraryData.total_mileage || itineraryData.total_milage || '---',
    workingDays: days,
    selectedVehicle: vehicleDetails.vehicleType || itineraryData.vehicleType || itineraryData.selected_vehicle || 'Not specified',
    customerName: itineraryData.customerName || itineraryData.customer_name || 'Not specified',
    customerId: itineraryData.customer_id || itineraryData.id || 'Not specified',
    numAdults: adultsChildrenData?.numAdults || 0,
    numChildren: adultsChildrenData?.numChildren || 0
  });

  // Set detailed cost breakdown using API values (withVAT, withoutVAT)
  setCostBreakdown({
    transport: totals.transport || { withVAT: 0, withoutVAT: 0 },
    accommodation: totals.accomodation || { withVAT: 0, withoutVAT: 0 },
    entranceFees: totals.location_ticket_price || { withVAT: 0, withoutVAT: 0 },
    miscellaneousExpenses: totals.miscellaneous_expenses || { withVAT: 0, withoutVAT: 0 },
    otherExpenses: totals.other_expenses || { withVAT: 0, withoutVAT: 0 },
    guideAccommodation: totals.guide_accommodation || { withVAT: 0, withoutVAT: 0 },
    markupFixedRate: { withVAT: 0, withoutVAT: 0 }, // For future use
    vat: { withVAT: 0, withoutVAT: 0 }, // For future use
    sellingRate: { withVAT: 0, withoutVAT: 0 } // For future use
  });
  
  setAccommodationByRoom(roomCategory || []);
  setPackagePrices(packagePricesData || {
    dbl_packedge_price: 0,
    sgl_packedge_price: 0,
    tpl_packedge_price: 0
  });

  setPerPersonAccommodationPrices(perPersonAccommodationPrices || {
    dbl_accomodation_price_per_person: 0,
    sgl_accomodation_price_per_person: 0,
    tpl_accomodation_price_per_person: 0
  });

  setTaxData(taxesData || []);
  setShowTaxes(taxStatus);
  
  // ADD THIS: Set margin values from API response
  if (profitMarginData) {
    console.log('Profit margin data from API:', profitMarginData);
    
    // Determine margin type and value based on API response
    if (profitMarginData.as_presentage?.status === true) {
      setMarginType('percentage');
      setMarginValue(profitMarginData.as_presentage?.value || 0);
    } else if (profitMarginData.as_value?.status === true) {
      setMarginType('value');
      setMarginValue(profitMarginData.as_value?.value || 0);
    } else {
      // Default if no margin is set
      setMarginType('percentage');
      setMarginValue(0);
    }
  } else {
    // Default if no profit margin data found
    setMarginType('percentage');
    setMarginValue(0);
  }
}, [fetchModuleTotalsData]);


  const [marginType, setMarginType] = useState('percentage'); // 'percentage' or 'value'
const [marginValue, setMarginValue] = useState(0); // Single margin value for all room types

// 2. Add function to calculate margin amount
const calculateMarginAmount = (baseAmount, marginValue, type) => {
  if (type === 'percentage') {
    return (baseAmount * marginValue) / 100;
  } else {
    return marginValue;
  }
};

// 3. Add function to handle margin input changes
const handleMarginChange = (value) => {
  setMarginValue(parseFloat(value) || 0);
};

const [marginSaving, setMarginSaving] = useState(false);
const [marginSaveStatus, setMarginSaveStatus] = useState('');

// 2. Add function to handle margin API call
const handleSaveMargin = async () => {
  if (!itineraryId || !token || marginValue <= 0) {
    setMarginSaveStatus('Please enter a valid margin value');
    return;
  }

  setMarginSaving(true);
  setMarginSaveStatus('');

  try {
    const requestBody = {
      itinerary_id: itineraryId,
      profit_margin: {
        as_presentage: {
          status: marginType === 'percentage',
          value: marginType === 'percentage' ? marginValue : 0
        },
        as_value: {
          status: marginType === 'value',
          value: marginType === 'value' ? marginValue : 0
        }
      }
    };

    console.log('Margin API Request Body:', requestBody);

    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_itinerary_profit_margin",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    console.log('Margin API Response:', responseData);
    
    setMarginSaveStatus('Margin settings saved successfully!');
    
    // Optional: Refresh the cost data after saving margin
    await fetchItineraryData();
    
  } catch (error) {
    console.error('Error saving margin settings:', error);
    setMarginSaveStatus('Failed to save margin settings. Please try again.');
  } finally {
    setMarginSaving(false);
  }
};



const calculateTaxAmount = (amount) => {
  if (!showTaxes || !taxData.length) return 0;
  const taxPercentage = taxData[0]?.tax_percentage || 0;
  return (amount * taxPercentage) / 100;
};

  // Define fetchItineraryData with useCallback to prevent recreation on each render
  const fetchItineraryData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_filtered_data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ itinerary_id: itineraryId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      const itineraryData = responseData.data;
      
      if (itineraryData) {
        setItinerary(itineraryData);
        await calculateCosts(itineraryData);
        
        // Extract days data from itinerary
        if (itineraryData.days && Array.isArray(itineraryData.days)) {
          setDays(itineraryData.days);
        } else if (itineraryData.itinerary_cost && Array.isArray(itineraryData.itinerary_cost)) {
          // If days array is not available, create it from itinerary_cost
          const daysFromCost = itineraryData.itinerary_cost.map(dayCost => ({
            number: parseInt(dayCost.day, 10),
            date: dayCost.date || ""
          }));
          setDays(daysFromCost);
        } else {
          // Fallback: create days array based on no_of_days
          const numberOfDays = itineraryData.no_of_days || 0;
          const daysArray = Array.from({ length: numberOfDays }, (_, i) => ({
            number: i + 1,
            date: ""
          }));
          setDays(daysArray);
        }
      } else {
        throw new Error("Itinerary data not found");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token, itineraryId, calculateCosts]);

  // Load the selected itinerary data when component mounts
  useEffect(() => {
    if (token && itineraryId) {
      fetchItineraryData();
    }
  }, [token, itineraryId, fetchItineraryData]);

  // Calculate total costs for both with and without VAT, EXCLUDING accommodation
  const totalCostWithVAT = Object.entries(costBreakdown)
  .filter(([key]) => key !== 'accommodation')
  .reduce((sum, [, cost]) => sum + (cost.withVAT || 0), 0);
const totalCostWithoutVAT = Object.entries(costBreakdown)
  .filter(([key]) => key !== 'accommodation')
  .reduce((sum, [, cost]) => sum + (cost.withoutVAT || 0), 0);
  const totalTaxAmount = showTaxes ? calculateTaxAmount(totalCostWithoutVAT) : 0;
const netTotal = totalCostWithVAT + totalCostWithoutVAT + totalTaxAmount;
const costPerPerson = summary.numAdults > 0 ? (netTotal / summary.numAdults) : 0;
  // Determine background style based on popup state
  const backgroundStyle = {
    backgroundImage: 'radial-gradient(circle at center, #f0f9ff, #e1f5fe)',
    filter: (isEntranceFeePopupOpen || isTransportPopupOpen) ? 'brightness(0.85)' : 'none'
  };

  


  // Excel export handler
  const handleDownloadExcel = () => {
  if (!costBreakdown || !itinerary) return;
    // Prepare cost table data
    const costRows = [
      ["Category", "With Tax ($)", "Without Tax ($)"],
      ["Transport", costBreakdown.transport.withVAT?.toFixed(2) ?? '0.00', costBreakdown.transport.withoutVAT?.toFixed(2) ?? '0.00'],
      ["Entrance Fees", costBreakdown.entranceFees.withVAT?.toFixed(2) ?? '0.00', costBreakdown.entranceFees.withoutVAT?.toFixed(2) ?? '0.00'],
      ["Miscellaneous Expenses", costBreakdown.miscellaneousExpenses.withVAT?.toFixed(2) ?? '0.00', costBreakdown.miscellaneousExpenses.withoutVAT?.toFixed(2) ?? '0.00'],
      ["Other Expenses", costBreakdown.otherExpenses.withVAT?.toFixed(2) ?? '0.00', costBreakdown.otherExpenses.withoutVAT?.toFixed(2) ?? '0.00'],
      ["Guide Accommodation", costBreakdown.guideAccommodation.withVAT?.toFixed(2) ?? '0.00', costBreakdown.guideAccommodation.withoutVAT?.toFixed(2) ?? '0.00'],
      ["Total", totalCostWithVAT.toFixed(2), totalCostWithoutVAT.toFixed(2)],
      ["Net Total", (totalCostWithVAT + totalCostWithoutVAT).toFixed(2), ""]
    ];

    // Accommodation by Room Category
   let accommodationSheet = null;
 
if (accommodationByRoom && accommodationByRoom.length > 0) {
  const roomTypes = ["dbl_total", "sgl_total", "tpl_total"];
  const labels = { dbl_total: "Double (DBL)", sgl_total: "Single (SGL)", tpl_total: "Triple (TPL)" };
  const roomRows = [["Room Type", "With Tax ($)", "Without Tax ($)", "Total ($)", "Per Person Cost ($)", "Package Price ($)"]];
  
  roomTypes.forEach(type => {
    const sumWithVAT = accommodationByRoom.reduce((sum, obj) => sum + (obj[type]?.with_VAT?.value ?? 0), 0);
    const sumWithoutVAT = accommodationByRoom.reduce((sum, obj) => sum + (obj[type]?.without_vat?.value ?? 0), 0);
    
    // Get per person cost from per_person_accomodation_price
    let perPersonCost = 0;
    if (type === 'dbl_total') perPersonCost = perPersonAccommodationPrices.dbl_accomodation_price_per_person || 0;
    if (type === 'sgl_total') perPersonCost = perPersonAccommodationPrices.sgl_accomodation_price_per_person || 0;
    if (type === 'tpl_total') perPersonCost = perPersonAccommodationPrices.tpl_accomodation_price_per_person || 0;
    
    // MODIFY THIS: Calculate package price as accommodation per person cost + total cost per person
    const packagePrice = perPersonCost + costPerPerson;
    
    roomRows.push([
      labels[type],
      sumWithVAT.toFixed(2),
      sumWithoutVAT.toFixed(2),
      (sumWithVAT + sumWithoutVAT).toFixed(2),
      perPersonCost.toFixed(2),
      packagePrice.toFixed(2)  // CHANGED: Use packagePrice instead of netTotalForRoom
    ]);
  });
  accommodationSheet = XLSX.utils.aoa_to_sheet(roomRows);
}

    // Create worksheet and workbook
    const ws = XLSX.utils.aoa_to_sheet(costRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cost Breakdown");
    if (accommodationSheet) {
      XLSX.utils.book_append_sheet(wb, accommodationSheet, "Accommodation by Room");
    }

    // Download
    XLSX.writeFile(wb, `Costing_${summary.customerName || 'Itinerary'}.xlsx`);
  };

const handleTaxToggle = async (checked) => {
  setTaxLoading(true); // Start loading
  setShowTaxes(checked);
  
  // Make API call for both checking and unchecking
  if (itineraryId && token) {
    try {
      const requestBody = { itinerary_id: itineraryId };
      console.log(`Tax API Request Body (${checked ? 'Adding' : 'Removing'} taxes):`, requestBody);
      
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_tax_for_without_tax_items",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log(`Tax API Response (${checked ? 'Adding' : 'Removing'} taxes):`, responseData);
      
      // Refresh the cost data after applying/removing taxes
      await fetchItineraryData();
      
    } catch (error) {
      console.error(`Error ${checked ? 'applying' : 'removing'} taxes:`, error);
      // Optionally show an error message to the user
      setError(`Failed to ${checked ? 'apply' : 'remove'} taxes. Please try again.`);
    } finally {
      setTaxLoading(false); // Stop loading
    }
  } else {
    setTaxLoading(false); // Stop loading if no token/itineraryId
  }
};


  return (
    <div className="bg-blue-50 text-gray-800 min-h-screen p-6 transition-all duration-300" style={backgroundStyle}>
      <button
        onClick={async () => {
          if (itineraryId && token) {
            try {
              const response = await makeAuthenticatedRequest(
                "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({ itinerary_id: itineraryId }),
                }
              );
              if (!response.ok) throw new Error("Failed to fetch itinerary for edit.");
              const responseData = await response.json();
              const itineraryDetails = responseData.data?.[0];
              if (itineraryDetails) {
                navigate("/home", { state: { editData: itineraryDetails, token } });
              } else {
                navigate(-1);
              }
            } catch (err) {
              navigate(-1);
            }
          } else {
            navigate(-1);
          }
        }}
        className="mb-6 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-3xl flex items-center font-bold text-base shadow"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>
      <div className="container mx-auto max-w-6xl">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <p className="text-blue-800 text-lg">Loading cost breakdown...</p>
          </div>
        ) : error ? (
          <div className="bg-red-100 p-4 rounded mb-4 border border-red-300">
            <p className="text-red-700">{error}</p>
            <p className="text-sm mt-2 text-red-600">Please go back and try again.</p>
          </div>
        ) : itinerary ? (
         <div className="border border-blue-200 rounded-xl p-6 relative overflow-y-auto" 
     style={{ 
       background: 'linear-gradient(to bottom right, #ffffff, #f0f9ff)',
       maxHeight: 'calc(100vh - 120px)' 
     }}>



            {/* Title with border */}
            <div className="text-center mb-8 pb-4 relative border-b border-blue-200">
              <h1 className="text-3xl font-bold text-blue-800 uppercase tracking-wider">TOTAL COST</h1>
            </div>

            {/* Customer Info - small text in corner */}
            <div className="absolute top-2 right-2 text-right">
              <div className="text-xs text-gray-500">
                <p>customer name: <span className="text-gray-700">{summary.customerName}</span></p>
                <p>Itinerary id: <span className="text-gray-700">{summary.customerId}</span></p>
              </div>
            </div>

            {/* Summary Section */}
           <div className="flex flex-col items-center justify-center mb-8">
  <div className="grid grid-cols-5 gap-6 w-full max-w-5xl text-center">
    <div className="col-span-1">
      <p className="text-blue-600">total milage</p>
      <p className="text-xl text-blue-900 font-semibold">{summary.totalMileage}</p>
    </div>
    <div className="col-span-1">
      <p className="text-blue-600">working days</p>
      <p className="text-xl text-blue-900 font-semibold">{summary.workingDays} Days</p>
    </div>
    <div className="col-span-1">
      <p className="text-blue-600">selected vehicle</p>
      <p className="text-xl text-blue-900 font-semibold">{summary.selectedVehicle}</p>
    </div>
    <div className="col-span-1">
      <p className="text-blue-600">adults</p>
      <p className="text-xl text-blue-900 font-semibold">{summary.numAdults}</p>
    </div>
    <div className="col-span-1">
      <p className="text-blue-600">children</p>
      <p className="text-xl text-blue-900 font-semibold">{summary.numChildren}</p>
    </div>
  </div>
</div>

<div className="flex items-center justify-center mb-6">
  <div className="flex items-center space-x-3 bg-white px-4 py-2 rounded-lg border border-blue-200 shadow-sm">
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        id="showTaxes"
        checked={showTaxes}
        onChange={(e) => handleTaxToggle(e.target.checked)}
        disabled={taxLoading}
        className={`w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 ${taxLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      />
      {taxLoading && (
        <svg className="animate-spin h-4 w-4 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
    </div>
    <label htmlFor="showTaxes" className={`text-sm text-gray-700 font-medium ${taxLoading ? 'opacity-50' : ''}`}>
      {taxLoading ? 'Processing...' : `Apply Taxes ${taxData.length > 0 ? `(${taxData[0].tax_name}: ${taxData[0].tax_percentage}%)` : ''}`}
    </label>
  </div>
</div>

            {/* Main Content Grid */}
            <div className="grid grid-cols-4 gap-6">
              {/* Left sidebar with category buttons */}
              <div className="col-span-1">
                <div className="space-y-3">
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'transport' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      console.log('Costing: Transport button clicked');
                      console.log('Costing: Opening transport popup with itinerary ID:', itineraryId);
                      setActiveCategory('transport');
                      setIsTransportPopupOpen(true);
                    }}
                  >
                    Transport
                  </button>
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'accommodation' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      console.log('Costing: Accommodation button clicked');
                      console.log('Costing: Opening accommodation popup with itinerary ID:', itineraryId);
                      setActiveCategory('accommodation');
                      setIsAccommodationPopupOpen(true);
                    }}
                  >
                    Accommodation
                  </button>
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'entranceFees' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      console.log('Costing: Entrance Fee button clicked');
                      console.log('Costing: Opening entrance fee popup with itinerary ID:', itineraryId);
                      setActiveCategory('entranceFees');
                      setIsEntranceFeePopupOpen(true);
                    }}
                  >
                    Entrance Fees
                  </button>
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'miscellaneousExpenses' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      setActiveCategory('miscellaneousExpenses');
                      setIsMiscellaneousExpensesPopupOpen(true);
                    }}
                  >
                    Miscellaneous Expenses
                  </button>
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'otherExpenses' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      console.log('Costing: Other Expenses button clicked');
                      console.log('Costing: Opening other expenses popup with itinerary ID:', itineraryId);
                      setActiveCategory('otherExpenses');
                      setIsOtherExpensesPopupOpen(true);
                    }}
                  >
                    Other Expenses
                  </button>
                  <button 
                    className={`w-full py-3 border border-blue-200 rounded text-center text-sm hover:bg-blue-100 transition ${activeCategory === 'guideAccommodation' ? 'bg-blue-200 text-blue-800 font-medium' : 'text-blue-700'}`}
                    onClick={() => {
                      console.log('Costing: Guide Accommodation button clicked');
                      console.log('Costing: Opening guide accommodation popup with itinerary ID:', itineraryId);
                      setActiveCategory('guideAccommodation');
                      setIsGuideAccommodationPopupOpen(true);
                    }}
                  >
                    Guide Accommodation
                  </button>
                </div>
              </div>

              {/* Right content - cost table */}
              <div className="col-span-3">
                <div className="border border-blue-200 rounded-md overflow-hidden shadow-sm">
               <table className="w-full text-sm">
  <thead>
    <tr className="bg-blue-100">
      <th className="px-4 py-2 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
        Category
      </th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">
        With Tax ($)
      </th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">
        Without Tax ($)
        {showTaxes && (
          <div className="text-xs font-normal text-red-600 mt-1">
            + Tax Amount ($)
          </div>
        )}
      </th>
    </tr>
  </thead>

<tbody className="divide-y divide-blue-100">
  <tr className="bg-white">
    <td className="px-4 py-3 text-gray-800">Transport</td>
    <td className="px-4 py-3 text-center text-gray-800">{costBreakdown.transport.withVAT?.toFixed(2) ?? '0.00'}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-gray-800">{costBreakdown.transport.withoutVAT?.toFixed(2) ?? '0.00'}</div>
      {showTaxes && (
        <div className="text-xs text-red-600 mt-1">
          + {calculateTaxAmount(costBreakdown.transport.withoutVAT || 0).toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-white">
    <td className="px-4 py-3 text-gray-800">Entrance Fees</td>
    <td className="px-4 py-3 text-center text-gray-800">{costBreakdown.entranceFees.withVAT?.toFixed(2) ?? '0.00'}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-gray-800">{costBreakdown.entranceFees.withoutVAT?.toFixed(2) ?? '0.00'}</div>
      {showTaxes && (
        <div className="text-xs text-red-600 mt-1">
          + {calculateTaxAmount(costBreakdown.entranceFees.withoutVAT || 0).toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-blue-50">
    <td className="px-4 py-3 text-gray-800">Miscellaneous Expenses</td>
    <td className="px-4 py-3 text-center text-gray-800">{costBreakdown.miscellaneousExpenses.withVAT?.toFixed(2) ?? '0.00'}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-gray-800">{costBreakdown.miscellaneousExpenses.withoutVAT?.toFixed(2) ?? '0.00'}</div>
      {showTaxes && (
        <div className="text-xs text-red-600 mt-1">
          + {calculateTaxAmount(costBreakdown.miscellaneousExpenses.withoutVAT || 0).toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-white">
    <td className="px-4 py-3 text-gray-800">Other Expenses</td>
    <td className="px-4 py-3 text-center text-gray-800">{costBreakdown.otherExpenses.withVAT?.toFixed(2) ?? '0.00'}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-gray-800">{costBreakdown.otherExpenses.withoutVAT?.toFixed(2) ?? '0.00'}</div>
      {showTaxes && (
        <div className="text-xs text-red-600 mt-1">
          + {calculateTaxAmount(costBreakdown.otherExpenses.withoutVAT || 0).toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-blue-50">
    <td className="px-4 py-3 text-gray-800">Guide Accommodation</td>
    <td className="px-4 py-3 text-center text-gray-800">{costBreakdown.guideAccommodation.withVAT?.toFixed(2) ?? '0.00'}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-gray-800">{costBreakdown.guideAccommodation.withoutVAT?.toFixed(2) ?? '0.00'}</div>
      {showTaxes && (
        <div className="text-xs text-red-600 mt-1">
          + {calculateTaxAmount(costBreakdown.guideAccommodation.withoutVAT || 0).toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-white font-bold">
    <td className="px-4 py-3 text-gray-900">Total</td>
    <td className="px-4 py-3 text-center text-blue-900">{totalCostWithVAT.toFixed(2)}</td>
    <td className="px-4 py-3 text-center">
      <div className="text-blue-900">{totalCostWithoutVAT.toFixed(2)}</div>
      {showTaxes && (
        <div className="text-xs text-red-700 mt-1 font-bold">
          + {totalTaxAmount.toFixed(2)}
        </div>
      )}
    </td>
  </tr>
  <tr className="bg-blue-200 font-extrabold">
    <td className="px-4 py-3 text-gray-900">Net Total</td>
    <td className="px-4 py-3 text-center text-blue-900 text-lg" colSpan="2">
      {netTotal.toFixed(2)}
    </td>
  </tr>
  {/* NEW ROW: Per Person Cost displayed separately */}
  <tr className="bg-blue-100 font-bold">
    <td className="px-4 py-3 text-gray-900">Per Person Cost </td>
    <td className="px-4 py-3 text-center text-purple-900 text-lg" colSpan="2">
      {summary.numAdults > 0 ? `${costPerPerson.toFixed(2)}` : 'N/A'}
    </td>
  </tr>
</tbody>
</table>
                </div>
              </div>
            </div>

            {/* Accommodation by Room Category Table */}
     {accommodationByRoom && accommodationByRoom.length > 0 && (
  <div className="mt-8 border border-blue-300 rounded-md overflow-hidden shadow-sm bg-white">
    <div className="bg-blue-100 px-4 py-2 border-b border-blue-200">
      <h2 className="text-lg font-semibold text-blue-800">Package Pricing by Room Category</h2>
    </div>

    <div className="mb-4 bg-blue-50 p-4 rounded-lg border border-blue-200">
  <h3 className="text-sm font-semibold text-blue-800 mb-3">Margin Settings</h3>
  
  {/* Single horizontal row with all margin controls */}
  <div className="flex items-center space-x-6 flex-wrap">
    {/* Radio buttons for margin type */}
    <div className="flex items-center space-x-3">
      <label className="flex items-center text-sm">
        <input
          type="radio"
          name="marginType"
          value="percentage"
          checked={marginType === 'percentage'}
          onChange={(e) => setMarginType(e.target.value)}
          className="mr-1"
        />
        Percentage (%)
      </label>
      <label className="flex items-center text-sm">
        <input
          type="radio"
          name="marginType"
          value="value"
          checked={marginType === 'value'}
          onChange={(e) => setMarginType(e.target.value)}
          className="mr-1"
        />
        Fixed Value ($)
      </label>
    </div>
    
    {/* Margin input */}
    <div className="flex items-center space-x-2">
      <label className="text-sm text-gray-700">Margin:</label>
      <input
        type="number"
        value={marginValue || ''}
        onChange={(e) => {
          handleMarginChange(e.target.value);
          setMarginSaveStatus(''); // Clear status when value changes
        }}
        placeholder={marginType === 'percentage' ? 'Enter %' : 'Enter $'}
        className="w-24 px-2 py-1 text-sm border border-gray-300 rounded"
        step={marginType === 'percentage' ? '0.1' : '0.01'}
        min="0"
      />
      <span className="text-sm text-gray-600">
        {marginType === 'percentage' ? '%' : '$'}
      </span>
    </div>
    
    {/* Save button - only show when margin value is entered */}
    {marginValue > 0 && (
      <div className="flex items-center space-x-3">
        <button
          onClick={handleSaveMargin}
          disabled={marginSaving}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            marginSaving 
              ? 'bg-gray-400 text-gray-700 cursor-not-allowed' 
              : 'bg-blue-600 hover:bg-blue-700 text-white'
          }`}
        >
          {marginSaving ? 'Saving...' : 'Save Margin Settings'}
        </button>
        
        {marginSaveStatus && (
          <span className={`text-sm ${
            marginSaveStatus.includes('success') 
              ? 'text-green-600' 
              : 'text-red-600'
          }`}>
            {marginSaveStatus}
          </span>
        )}
      </div>
    )}
  </div>
</div>
  <table className="w-full text-sm">
  <thead>
    <tr className="bg-blue-50">
      <th className="px-4 py-2 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">Room Type</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">With Tax ($)</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">
        Without Tax ($)
        {showTaxes && (
          <div className="text-xs font-normal text-red-600 mt-1">
            + Tax Amount ($)
          </div>
        )}
      </th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">Total ($)</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">Per Person Cost ($)</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">Package Cost($)</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">Margin Amount ($)</th>
      <th className="px-4 py-2 text-center text-xs font-medium text-blue-700 uppercase tracking-wider">Package Price with Margin ($)</th>
    </tr>
  </thead>
  <tbody className="divide-y divide-blue-100">
    {['dbl_total', 'sgl_total', 'tpl_total'].map((type, idx) => {
      const sumWithVAT = accommodationByRoom.reduce((sum, obj) => sum + (obj[type]?.with_VAT?.value ?? 0), 0);
      const sumWithoutVAT = accommodationByRoom.reduce((sum, obj) => sum + (obj[type]?.without_vat?.value ?? 0), 0);
      
      let perPersonCost = 0;
      if (type === 'dbl_total') {
        perPersonCost = perPersonAccommodationPrices.dbl_accomodation_price_per_person || 0;
      }
      if (type === 'sgl_total') {
        perPersonCost = perPersonAccommodationPrices.sgl_accomodation_price_per_person || 0;
      }
      if (type === 'tpl_total') {
        perPersonCost = perPersonAccommodationPrices.tpl_accomodation_price_per_person || 0;
      }
      
      const accommodationTaxAmount = showTaxes ? calculateTaxAmount(sumWithoutVAT) : 0;
      const accommodationTotal = sumWithVAT + sumWithoutVAT + accommodationTaxAmount;
      
      // Calculate base package price (without margin)
      const basePackagePrice = perPersonCost + costPerPerson;
      
      // Calculate margin amount based on base package price
      const marginAmount = calculateMarginAmount(basePackagePrice, marginValue, marginType);
      
      // Calculate final package price with margin
      const finalPackagePrice = basePackagePrice + marginAmount;
      
      let label = '';
      if (type === 'dbl_total') label = 'Double (DBL)';
      if (type === 'sgl_total') label = 'Single (SGL)';
      if (type === 'tpl_total') label = 'Triple (TPL)';
      
      return (
        <tr key={type} className={idx % 2 === 0 ? 'bg-white' : 'bg-blue-50'}>
          <td className="px-4 py-3 text-gray-800">{label}</td>
          <td className="px-4 py-3 text-center text-gray-800">{sumWithVAT.toFixed(2)}</td>
          <td className="px-4 py-3 text-center">
            <div className="text-gray-800">{sumWithoutVAT.toFixed(2)}</div>
            {showTaxes && (
              <div className="text-xs text-red-600 mt-1">
                + {accommodationTaxAmount.toFixed(2)}
              </div>
            )}
          </td>
          <td className="px-4 py-3 text-center text-blue-900 font-semibold">{accommodationTotal.toFixed(2)}</td>
          <td className="px-4 py-3 text-center text-purple-900 font-semibold">{perPersonCost.toFixed(2)}</td>
          <td className="px-4 py-3 text-center text-green-900 font-semibold">{basePackagePrice.toFixed(2)}</td>
          <td className="px-4 py-3 text-center text-orange-900 font-semibold">{marginAmount.toFixed(2)}</td>
          <td className="px-4 py-3 text-center text-green-900 font-bold">{finalPackagePrice.toFixed(2)}</td>
        </tr>
      );
    })}
  </tbody>
</table>
  </div>
)}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-64 text-center">
            <svg 
              className="w-16 h-16 text-blue-300 mb-4" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              ></path>
            </svg>
            <p className="text-blue-500 text-lg">
              No itinerary data found
            </p>
          </div>
        )}
      </div>
      
      {/* Entrance Fee Popup */}
      <EntranceFeePopup 
        isOpen={isEntranceFeePopupOpen}
        onClose={() => {
          setIsEntranceFeePopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
        days={days}
      />
      
      {/* Miscellaneous Expenses Popup */}
      <MiscellaneousExpensesPopup
        isOpen={isMiscellaneousExpensesPopupOpen}
        onClose={() => {
          setIsMiscellaneousExpensesPopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
        days={days}
      />

      {/* Other Expenses Popup */}
      <OtherExpensesPopup
        isOpen={isOtherExpensesPopupOpen}
        onClose={() => {
          setIsOtherExpensesPopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
      />

      {/* Guide Accommodation Popup */}
      <GuideAccommodationPopup
        isOpen={isGuideAccommodationPopupOpen}
        onClose={() => {
          setIsGuideAccommodationPopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
      />

      {/* Accommodation Popup */}
      <AccommodationPopup
        isOpen={isAccommodationPopupOpen}
        onClose={() => {
          setIsAccommodationPopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
      />
      
      {/* Transport Popup */}
      <TransportPopup
        isOpen={isTransportPopupOpen}
        onClose={() => {
          setIsTransportPopupOpen(false);
          // Refresh cost data when popup is closed
          if (token && itineraryId) {
            fetchItineraryData();
          }
        }}
        itineraryId={itineraryId}
      />
      {/* Floating Download Excel Button */}
      {itinerary && !loading && (
        <>
        <button
  onClick={async () => {
    setExcelError("");
    setExcelLink("");
    setShowExcelLink(false);
    setExcelLoading(true);
    
    if (itineraryId && token) {
      try {
        const response = await fetch("https://excelsheet-generate-v1-14140141147.us-central1.run.app", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ itinerary_id: itineraryId })
        });
        const data = await response.json().catch(() => ({}));
        console.log("Excel generation API response:", response, data);
        if (data && data.document_link) {
          setExcelLink(data.document_link);
          setShowExcelLink(true);
        } else {
          setExcelError("No document link found in API response.");
        }
      } catch (err) {
        setExcelError("Error calling Excel generation API.");
        console.error("Error calling Excel generation API:", err);
      } finally {
        setExcelLoading(false);
      }
    } else {
      setExcelLoading(false);
    }
  }}
  className={`fixed z-50 bottom-10 right-10 bg-blue-600 hover:bg-blue-700 text-white shadow-xl rounded-full w-12 h-12 flex flex-col items-center justify-center transition duration-200 focus:outline-none focus:ring-4 focus:ring-blue-300 group ${isAnyPopupOpen ? 'filter blur-sm pointer-events-none opacity-60' : ''} ${excelLoading ? 'cursor-not-allowed opacity-75' : ''}`}
  title={excelLoading ? "Generating Excel..." : "Download cost breakdown as Excel"}
  disabled={isAnyPopupOpen || excelLoading}
>
  {excelLoading ? (
    <svg className="animate-spin h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 10l5 5 5-5M12 15V3" />
    </svg>
  )}
  <span className="absolute opacity-0 group-hover:opacity-100 bg-gray-900 text-white text-xs rounded py-1 px-2 right-20 top-1/2 -translate-y-1/2 whitespace-nowrap transition-opacity duration-200 pointer-events-none">
    {excelLoading ? "Generating..." : "Download Excel"}
  </span>
</button>
          {/* Show download link if available */}
       
{excelLink && showExcelLink && (
  <div className="fixed z-50 bottom-24 right-10 bg-white border border-blue-400 rounded shadow-lg px-4 py-3 flex items-center space-x-3">
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 10l5 5 5-5M12 15V3" />
    </svg>
    <a href={excelLink} target="_blank" rel="noopener noreferrer" className="text-blue-700 underline font-semibold">Download Excel File</a>
    <button
      onClick={() => setShowExcelLink(false)}
      className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
      title="Close"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
)}
        </>
      )}
    </div>
  );
};

export default Costing;
